export const growthbookConfig = {
  key: process.env.REACT_APP_GROWTHBOOK_KEY,
}
